import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue';
import router from './router';
import { ensureSession, redirectToLogin } from './utils/auth';

Vue.use(ElementUI);

Vue.config.productionTip = false;

// 先确认登录态再挂载：未登录跳统一登录页
ensureSession()
  .then(user => {
    if (!user) return; // 已跳转登录页
    new Vue({
      router,
      render: h => h(App),
    }).$mount('#app');
  })
  .catch(() => {
    // 网络异常时跳登录页重试
    redirectToLogin();
  });
